import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { catchError, map, Observable, of, take } from 'rxjs';
import { GS1NotificationService } from '@gs1france/gs1-components-library';
import { EventModel } from '../models/events.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  apiUrl = `${environment.URL_API}api/events`;
  
  http = inject(HttpClient);
  translateService = inject(TranslateService);

  notificationService = inject(GS1NotificationService);
  
  getEvents(limit: number): Observable<EventModel[]> {
    return this.http.get<{ events: EventModel[] }>(this.apiUrl)
    .pipe(
      take(1),
      map((responses: { events: EventModel[] }) => {
        return responses.events.sort((a, b) => a.endDate.localeCompare(b.endDate)).slice(0, limit);
      }),
      catchError((error) => {
        console.error('Error fetching events:', error);
        this.notificationService.addNotification(this.translateService.instant('home.agenda.error'), 'error');
        return of([]); 
      })
    );
  }
}
